module.exports = __webpack_public_path__ + "static/media/108-armenia.aab0ed74.svg";